// #region TEST IDs
export const COLLAPSE_ICON_TEST_ID = "collapse-icon";
export const EXPAND_ICON_TEST_ID = "expand-icon";
// #endregion
